import axios from "axios";
import { servicios } from "../properties";

export const SET_PAGO_DEDUCIBLE_AUTO = "set_pago_deducible_auto";
export const SET_DETALLE_PAGO_DEDUCIBLE = "set_detalle_pago_deducible";
export const SET_DATOS_EMITIR_CFDI = "set_datos_emitir_cfdi";
export const SET_CFDI = "set_cfdi";
export const SET_GET_DETALLE_PAGO = "set_get_detalle_pago";
export const ESTADO_INICIAL = "estado_inicial";
export const DISABLED_BUTTON_PAGO = "disabled_button_pago"
export const RESET_PAGO_LINEA = "reset_pago_linea"
export const estadoInicial = () => {
	return (dispatch) => {
		dispatch({ type: ESTADO_INICIAL });
	};
};

export const resetPagoLinea = () => {
	return (dispatch) => {
		dispatch({ type: RESET_PAGO_LINEA });
	}
}

export const setDisabledButtonPago = (nameInput, inputValid ) => {
	return (dispatch) => {
		dispatch({
			type: DISABLED_BUTTON_PAGO,
			payload: {nameInput,inputValid}
		});
	}
}

export const setDatosEmitirCfdi = (dataEmitir) => {
	return (dispatch) => {
		dispatch({
			type: SET_DATOS_EMITIR_CFDI,
			payload: dataEmitir,
		});
	};
};

export const setGetDetallePago = (dataGetDetallePago) => {
	return (dispatch) => {
		dispatch({
			type: SET_GET_DETALLE_PAGO,
			payload: dataGetDetallePago,
		});
	};
};

export const setCfdi = (option) => {
	return (dispatch) => {
		dispatch({
			type: SET_CFDI,
			payload: option,
		});
	};
};

export const datosPagoDeducible = (data) => {
	return (dispatch) => {
		dispatch({
			type: SET_PAGO_DEDUCIBLE_AUTO,
			payload: data,
		});
	};
};

export const onLoading = (mostrar) => {
	return (dispatch) => {
		dispatch({
			type: "LOADER",
			show: mostrar,
		});
	};
};

export const getDetallePago = (codigoSiniestro, tokId) => {
	return (dispatch) => {
		return axios({
			method: "GET",
			url: `${servicios.pagoDeducibleAutos.urlBaseCF}/pagoDeducibleAuto/detallePago`,
			headers: {
				authorization: tokId,
			},
			params: {
				codSiniestro: codigoSiniestro,
			},
		});
	};
};

export const getReferenciaBancaria = (codigoSiniestro, tokId) => {
	return (dispatch) => {
		return axios({
			method: "GET",
			url: `${servicios.pagoDeducibleAutos.urlBaseCF}/pagoDeducibleAuto/documentoReferenciasBancarias`,
			headers: {
				authorization: tokId,
			},
			params: {
				codSiniestro: codigoSiniestro,
			},
		});
	};
};

export const postPagoBancario = (tokId, body) => {
	return (dispatch) => {
		return axios({
			method: "POST",
			url: `${servicios.pagoDeducibleAutos.urlBaseCF}/pagoDeducibleAuto/pagar`,
			headers: {
				authorization: tokId,
			},
			data: { ...body },
		});
	};
};

export const postCorreoGuiaPago = (tokId) => {
	return (dispatch) => {
		return axios({
			method: "POST",
			url: `${servicios.pagoDeducibleAutos.urlBaseCF}/pagoDeducibleAuto/notificar-guia-pago`,
			headers: {
				authorization: tokId,
			},
		});
	};
};

export const postCorreoReferenciaBancaria = (tokId, body) => {
	return (dispatch) => {
		return axios({
			method: "POST",
			url: `${servicios.pagoDeducibleAutos.urlBaseCF}/pagoDeducibleAuto/notificar-referencia-bancaria`,
			headers: {
				authorization: tokId,
			},
			data: { ...body },
		});
	};
};

export const getConsultaCfdi = (numeroCliente, tokId) => {
	return (dispatch) => {
		return axios({
			method: "GET",
			url: `${servicios.pagoDeducibleAutos.urlBaseCF}/pagoDeducibleAuto/siniestrosCFDI`,
			headers: {
				authorization: tokId,
			},
			params: {
				numeroCliente,
			},
		});
	};
};

export const postEstatusPago = (body, tokId) => {
	return (dispatch) => {
		return axios({
			method: "POST",
			url: `${servicios.pagoDeducibleAutos.urlBaseCF}/pagoDeducibleAuto/estatusPago`,
			headers: {
				authorization: tokId,
			},
			data: {
				siniestros: body,
			},
		});
	};
};

export const getFiscalesCfdi = (poliza, tokId) => {
	return (dispatch) => {
		return axios({
			method: "GET",
			url: `${servicios.pagoDeducibleAutos.urlBaseCF}/pagoDeducibleAuto/datosFiscales`,
			headers: {
				authorization: tokId,
			},
			params: {
				poliza,
			},
		});
	};
};

export const getBanco = (codigoBin, tokId) => {
	return (dispatch) => {
		return axios({
			method: "GET",
			url: `${servicios.pagoDeducibleAutos.urlBaseCF}/pagoDeducibleAuto/recuperarBanco`,
			headers: {
				authorization: tokId,
			},
			params: {
				bin: codigoBin,
			},
		});
	};
};

export const postCorreoNotificarComprobante = (file, siniestro, codigo, tokId) => {
	return (dispatch) => {
		return axios({
			method: "POST",
			url: `${servicios.pagoDeducibleAutos.urlBaseCF}/pagoDeducibleAuto/notificar-comprobante`,
			headers: {
				authorization: tokId,
			},
			data: {
				codSiniestro: siniestro,
				authorizationCode: codigo,
				pdfComprobante: file,
			},
		});
	};
};

export const postTimbradoCfdi = (body, tokId) => {
	return (dispatch) => {
		return axios({
			method: "POST",
			url: `${servicios.pagoDeducibleAutos.urlBaseCF}/pagoDeducibleAuto/solicitarCFDI`,
			headers: {
				authorization: tokId,
			},
			data: { ...body },
		});
	};
};

export const getRfcValido = (rfc, tokId) => {
	return (dispatch) => {
		return axios({
			method: "POST",
			url: `${servicios.pagoDeducibleAutos.urlBaseCF}/pagoDeducibleAuto/validaEmisionRfc`,
			headers: {
				authorization: tokId,
			},
			data: {
				rfcs: [rfc],
			},
		});
	};
};



// WEBPACK FOOTER //
// ./src/pago-deducible-auto/pagoDeducibleAuto-actions.js